import React, { Component } from 'react';
import { isSubmitting, reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';

import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import { Checkbox } from 'redux-form-material-ui';
import accessibleDatePicker from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';
import * as validator from 'helpers/Validator';
import { colors } from 'helpers/ColorHelper';
import { RenderError } from 'helpers/Formatter';

import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';
import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import { getTranslatedString } from 'helpers/i18n';
import { eventPhotoAcceptedFileTypes } from 'helpers/FileHelper';

const config = {
  IMAGE_SIZE: 3_000_000,
};

let EventForm = class extends Component {
  render() {
    const { properties } = this.props;

    const style = {
      receipt_header: {
        margin: '5px 0px 10px 0px',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
        borderRadius: '8px',
      },
    };

    return (
      <div>
        <div className="row" style={style.receipt_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {' '}
              {getTranslatedString('landlordPortal.addEventDialog.propertyUpcase')}{' '}
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ margin: '10px 0' }}>
            <Field
              name="properties"
              data={properties}
              component={MultiSelectExtended}
              multiple
              hintText={getTranslatedString('landlordPortal.addEventDialog.properties')}
              innerDivStyle={{
                width: '100%',
                fontSize: '15px',
                fontWeight: '100 !important',
              }}
              menuStyle={{ minWidth: '250px', fontSize: '15px' }}
              style={{ fontSize: '15px' }}
              fullWidth
              withResetSelectAllButtons
            />
            <Field name="properties" component={RenderError} />
          </div>
        </div>

        <div className="row" style={style.receipt_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {' '}
              {getTranslatedString('landlordPortal.addEventDialog.eventDetailsUpcase')}{' '}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12" style={{ marginBottom: '7px' }}>
            <Field
              name="name"
              type="text"
              component={TextField}
              label={getTranslatedString('landlordPortal.addEventDialog.eventName')}
              style={{ fontSize: '14px', marginBottom: '10px' }}
              validate={[validator.required]}
              variant="outlined"
            />
          </div>
          <div className="col-xs-12">
            <Field
              name="description"
              type="text"
              component={TextField}
              label={getTranslatedString('landlordPortal.addEventDialog.eventDescription')}
              style={{ fontSize: '14px' }}
              validate={[validator.required]}
              multiline
              rows={3}
              variant="outlined"
            />
          </div>
          <div className="col-xs-12" style={{ marginTop: '15px' }}>
            <Field
              name="link"
              type="text"
              component={TextField}
              label={getTranslatedString('landlordPortal.addEventDialog.eventLink')}
              style={{ fontSize: '14px' }}
              variant="outlined"
              validate={[validator.validURL]}
            />
          </div>
          <div className="col-xs-12" style={{ marginTop: '15px' }}>
            <Field
              name="link_alt"
              type="text"
              component={TextField}
              label={getTranslatedString('landlordPortal.addEventDialog.eventLinkAlt')}
              style={{ fontSize: '14px' }}
              variant="outlined"
            />
          </div>
          <div className="col-sm-12" style={{ marginTop: '15px' }}>
            <Field
              name="post_date"
              component={accessibleDatePicker}
              fullWidth
              validate={[validator.required]}
              label={getTranslatedString('landlordPortal.addEventDialog.postDate')}
              minDate={new Date()}
              style={{ fontSize: '14px' }}
              showTimeSelect
              textFieldStyle={{ fontSize: '14px' }}
              dateFormat="Pp"
            />{' '}
          </div>
          <div className="col-sm-12" style={{ marginTop: '15px' }}>
            <Field
              name="start_date"
              component={accessibleDatePicker}
              label={getTranslatedString('landlordPortal.addEventDialog.startDate')}
              minDate={new Date()}
              fullWidth
              validate={[validator.required]}
              showTimeSelect
              dateFormat="Pp"
            />{' '}
          </div>
          <div className="col-sm-12" style={{ marginTop: '15px' }}>
            <Field
              name="end_date"
              component={accessibleDatePicker}
              label={getTranslatedString('landlordPortal.addEventDialog.endDate')}
              minDate={new Date()}
              fullWidth
              validate={[validator.required]}
              showTimeSelect
              dateFormat="Pp"
            />{' '}
          </div>
          <div className="col-sm-6" style={{ marginBottom: '10px' }}>
            <div style={{ maxWidth: '259px', margin: 'auto' }}>
              <Field
                name="show_to_tenants"
                component={Checkbox}
                label={getTranslatedString('landlordPortal.addEventDialog.showEventInTenantPortal')}
                labelPosition="right"
                style={{ marginTop: '10px' }}
              />
            </div>
          </div>
          <div className="col-sm-6" style={{ marginBottom: '10px' }}>
            <div style={{ maxWidth: '259px', margin: 'auto' }}>
              <Field
                name="can_rsvp"
                component={Checkbox}
                label={getTranslatedString('landlordPortal.addEventDialog.allowTenantsToRsvp')}
                labelPosition="right"
                style={{ marginTop: '10px' }}
              />
            </div>
          </div>
          <div className="col-sm-6" style={{ marginBottom: '10px' }}>
            <div style={{ maxWidth: '259px', margin: 'auto' }}>
              <Field
                name="notify_residents"
                component={Checkbox}
                label={getTranslatedString('landlordPortal.addEventDialog.notifyResidents')}
                labelPosition="right"
                style={{ marginTop: '10px' }}
              />
            </div>
          </div>
          {this.props.initialValues.name && (
            <div className="col-sm-6" style={{ marginBottom: '10px' }}>
              <div style={{ maxWidth: '259px', margin: 'auto' }}>
                <Field
                  name="send_on_update"
                  component={Checkbox}
                  label={getTranslatedString('landlordPortal.addEventDialog.sendOnUpdate')}
                  labelPosition="right"
                  style={{ marginTop: '10px' }}
                />
              </div>
            </div>
          )}
        </div>
        <div className="row" style={style.receipt_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {' '}
              {getTranslatedString('landlordPortal.addEventDialog.eventPhotoUpcase')}{' '}
            </p>
          </div>
        </div>
        <div style={{ padding: '0 15px' }}>
          <p>{getTranslatedString('landlordPortal.addEventDialog.addAPhoto')}</p>
          <div className="row" style={{ textAlign: 'center' }}>
            <Field
              name="photo"
              style={{
                border: `1px dashed ${colors.LIGHT_GRAY}`,
                width: '60%',
                margin: 'auto',
              }}
              labelText={getTranslatedString('landlordPortal.addEventDialog.clickToAddPhoto')}
              component={ReduxDropzone}
              fileValidation={eventPhotoAcceptedFileTypes}
              size={120}
              multiple={false}
              validate={[validator.required]}
              maxFileSize={config.IMAGE_SIZE}
            />
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (store, ownProps) => {
  return {
    initialValues: ownProps.initialValues,
    amenities: store.landlordProperties.amenities,
    amenity: store.landlordProperties.amenity,
    tenantsForMultiselect: store.landlordProperties.tenants,
    properties: store.landlordProperties.properties,
    units: store.landlordProperties.units,
    unitActiveLease: store.landlordProperties.unitActiveLease,
    submitting: isSubmitting('event_form')(store),
  };
};

export default EventForm = compose(
  connect(mapStateToProps),
  reduxForm({
    form: 'event_form',
    initialValues: { properties: [] },
  })
)(EventForm);
